// components/portal/GlobalChatList.tsx
'use client';

import { useEffect, useRef } from 'react';
import { useKernelStore } from '@/kernel/kernelStores';
import { DaimonStage } from '@/components/daimon/DaimonVoice';

/** Home is the Daimon: the blue bubble alone, no chat box (owner, 2026-09-28). */
export const GlobalChatList = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const setGlobalScrollTop = useKernelStore((state) => state.setGlobalScrollTop);

  useEffect(() => {
    const node = scrollRef.current;
    if (!node) return;

    const handleScroll = () => setGlobalScrollTop(node.scrollTop);
    handleScroll();

    node.addEventListener('scroll', handleScroll, { passive: true });
    return () => node.removeEventListener('scroll', handleScroll);
  }, [setGlobalScrollTop]);

  return (
    <div className="relative flex h-full w-full">
      <section
        ref={scrollRef}
        className="custom-scrollbar relative z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto px-6 text-white md:px-12"
      >
        <DaimonStage />
      </section>
    </div>
  );
};
